module.exports = __webpack_public_path__ + "static/media/NewDesignHrExport.8974a394.svg";